module.exports = __webpack_public_path__ + "media/2x/M-73e449c8.png";